export default "__VITE_ASSET__BuO45aIZ__"